/**
 * Created by anatoly on 06.02.2025
 */

cleverapps.styles.UI.Button.Images.serve_button = {
    button_png: bundles.questsgroupicon.frames.serve_button,
    button_on_png: bundles.questsgroupicon.frames.serve_button_on,
    maxFontSize: 42,
    SKIP_RESOLUTION: {
        padding: {
            left: 0.3,
            right: 0.3,
            top: 0.01,
            bottom: 0.09
        }
    }
};

cleverapps.styles.UI.Button.Images.orders_check_button = {
    button_png: bundles.questsgroupicon.frames.orders_check_button_png,
    button_on_png: bundles.questsgroupicon.frames.orders_check_button_png
};

cleverapps.styles.SQUARE_MODE_WIDTH = 1125;
cleverapps.styles.HORIZONTAL_MODE_WIDTH = 1760;

cleverapps.overrideStyles(cleverapps.styles.CupComponentView, {
    progress: {
        y: { align: "center", dy: -66 },
        type: ScaledProgressBar.Types.green_small
    }
});

cleverapps.overrideStyles(cleverapps.styles.SpecialEnergyOfferWindow, {
    person: "hero",

    reward: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 150 }
    },

    animation: {
        x: { align: "center" },
        y: { align: "center", dy: -20 }
    },

    margin: 50
});

cleverapps.overrideStyles(cleverapps.styles.TreasureBag, {
    position: {
        x: { align: "right", dx: -10 },
        y: { align: "bottom", dy: 300 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ExtraBarIconView, {
    width: 160,
    height: 160,
    margin: 25
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ROW_ICON_TEXT: {
        name: "lightstroke",
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    UNIT_LIBRARY_LEVEL_TEXT: {
        name: "default",
        size: 50,
        color: new cc.Color(209, 150, 129, 255)
    },

    UNIT_LIBRARY_TEXT: {
        name: "default",
        color: new cc.Color(209, 150, 129, 255),
        size: 43
    },

    ENERGY_BOOSTER_WINDOW_TEXT: {
        name: "nostroke",
        color: new cc.Color(209, 150, 129, 255),
        size: 36
    },

    ENERGY_OFFER: {
        size: 80
    },

    PACKWINDOW_TEXT: {
        size: 90,
        color: cleverapps.styles.COLORS.COLOR_LIGHT_YELLOW,
        shadow: cleverapps.styles.DECORATORS.LIGHT_YELLOW_SHADOW
    },

    PACKWINDOW_LABEL_TEXT: {
        size: 60,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    MERGE2_OFFER_TITLE_TEXT: {
        size: 80,
        color: cc.hexToColor("fffef4"),
        stroke: {
            size: 2,
            color: cc.hexToColor("c86719")
        },
        shadow: {
            color: cc.hexToColor("c86719"),
            direction: cc.size(0, -2)
        }
    },

    MISSION_TIMER_TEXT: {
        name: "nostroke",
        size: 52,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.overrideStyles(cleverapps.styles.RestoreProgressButton, {
    position: [
        {
            x: { align: "left", dx: 0},
            y: { align: "top", dy: 0 }
        },
        {
            x: { align: "left", dx: 0},
            y: { align: "bottom", dy: 200 }
        },
        {
            x: { align: "right", dx: 0},
            y: { align: "top", dy: -100 }
        }
    ]

});

cleverapps.overrideStyles(cleverapps.styles.MenuBarItem, {
    items: {
        GoldItem: {
            icon: {
                scale: 0.95
            }
        },

        LivesItem: {
            icon: {
                scale: 0.95
            }
        },

        OrderStarsItem: {
            icon: {
                scale: 1.05
            }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.AvatarMenuBarView, {
    avatar: {
        size: [{
            width: 170,
            height: 170
        }, {
            width: 145,
            height: 145
        }, {
            width: 145,
            height: 145
        }]
    },

    level: {
        text: {
            x: { align: "center" },
            y: { align: "center", dy: 0 },

            width: 40
        },

        alignment: [{
            x: { align: "left", dx: -10 },
            y: { align: "bottom", dy: -32 }
        }, {
            x: { align: "left", dx: -10 },
            y: { align: "bottom", dy: -26 }
        }, {
            x: { align: "left", dx: -10 },
            y: { align: "bottom", dy: -26 }
        }]
    },

    progress: {
        x: { align: "center" },
        y: { align: "bottom", dy: -4 },

        width: [125, 100, 100]
    },
});

cleverapps.overrideStyles(cleverapps.styles.DialogueViewVertical, {
    colorTypes: {
        hero: 0,
        artist: 1,
        elf: 2,
        taxidriver: 3,
        policeman: 4,
        repairman: 5,
        detective: 6,
        king: 7
    },
    textColors: [
        "566976",
        "56795d",
        "765b76",
        "823b3b",
        "b0603d",
        "478b6a",
        "624787",
        "b78306"
    ],
    titleStrokeColors: [
        "45819a",
        "3a8249",
        "b04fb0",
        "a53636",
        "b4603b",
        "288c5b",
        "4a419f",
        "b78518"
    ],
});

(function () {
    const fonts = {};
    const colors = cleverapps.styles.DialogueViewVertical.textColors;
    const titleStrokeColors = cleverapps.styles.DialogueViewVertical.titleStrokeColors;
    for (let i = 0; i < colors.length; i++) {
        fonts[`DIALOGUE_VERTICAL_${i}`] = {
            size: 34,
            color: cc.hexToColor(colors[i])
        };

        fonts[`DIALOGUE_VERTICAL_TITLE_${i}`] = {
            size: 40,
            color: cleverapps.styles.COLORS.WHITE,
            stroke: {
                color: cc.hexToColor(titleStrokeColors[i]),
                size: 2
            }
        };
    }

    cleverapps.overrideFonts(cleverapps.styles.FONTS, fonts);
}());

cleverapps.overrideStyles(cleverapps.styles.GroundedView, {
    rewardFog: {
        scale: 0.8,
        offset: {
            x: -12,
            y: -8
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.FieldRewardView, {
    position: { x: { align: "right" }, y: { align: "top" } },
    scale: 0.5,
    verticalScale: 0.6,

    icon: {
        width: 112,
        height: 112,
        withTextPosition: { y: { dy: 20 } }
    },

    energyIcon: {
        width: 76,
        height: 96
    },

    text: {
        position: { y: { dy: -26 } }
    },

    attention: {
        scale: 1.54,
        position: { x: { dx: 42 }, y: { dy: 46 } }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    FIELD_REWARD_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(148, 86, 45, 255),
            size: 4
        }
    }
});
